/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_wu_hub_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`An anagram uses all of your letters exactly. Unscrambling also finds shorter words that use only some of your letters — useful for board games.`)
};

const es_wu_hub_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Un anagrama usa exactamente todas tus letras. Descifrar también encuentra palabras más cortas que usan solo algunas de tus letras, útil para juegos de mesa.`)
};

const de_wu_hub_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ein Anagramm verwendet genau alle deine Buchstaben. Beim Entwirren werden zusätzlich kürzere Wörter gefunden, die nur einen Teil deiner Buchstaben nutzen – nützlich für Brettspiele.`)
};

const nl_wu_hub_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Een anagram gebruikt precies al je letters. Ontwarren vindt ook kortere woorden die maar een deel van je letters gebruiken — handig voor bordspellen.`)
};

const fr_wu_hub_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Un anagramme utilise exactement toutes vos lettres. Le déchiffrage trouve aussi des mots plus courts qui n'utilisent qu'une partie de vos lettres — utile pour les jeux de société.`)
};

const it_wu_hub_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Un anagramma usa esattamente tutte le tue lettere. Lo sblocco trova anche parole più corte che usano solo alcune delle tue lettere — utile per i giochi da tavolo.`)
};

const pt_br2_wu_hub_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Um anagrama usa exatamente todas as suas letras. O desembaralhamento também encontra palavras mais curtas que usam só algumas das suas letras — útil para jogos de tabuleiro.`)
};

const pt_wu_hub_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Um anagrama utiliza exatamente todas as suas letras. O desbaralhamento também encontra palavras mais curtas que usam apenas algumas das suas letras — útil para jogos de tabuleiro.`)
};

const ja_wu_hub_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`アナグラムは手持ちの文字をすべてちょうど使い切ります。文字の並べ替えでは、文字の一部だけを使った短い単語も見つかります — ボードゲームで役立ちます。`)
};

const zh_wu_hub_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`易位构词会用尽你手中的全部字母。而字母重组还能找到只使用部分字母的较短单词——这对桌游很有用。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const wu_hub_faq2_a = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.wu_hub_faq2_a(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("wu_hub_faq2_a", locale)
	if (locale === "en") return en_wu_hub_faq2_a(inputs)
	if (locale === "es") return es_wu_hub_faq2_a(inputs)
	if (locale === "de") return de_wu_hub_faq2_a(inputs)
	if (locale === "nl") return nl_wu_hub_faq2_a(inputs)
	if (locale === "fr") return fr_wu_hub_faq2_a(inputs)
	if (locale === "it") return it_wu_hub_faq2_a(inputs)
	if (locale === "pt-BR") return pt_br2_wu_hub_faq2_a(inputs)
	if (locale === "pt") return pt_wu_hub_faq2_a(inputs)
	if (locale === "ja") return ja_wu_hub_faq2_a(inputs)
	return zh_wu_hub_faq2_a(inputs)
};